<div class="message-center-thread-content-header bg-white">
  <div class="p-2">
    Select a category or sub category below to get started. An SEAA representative will be with you shortly.
  </div>
</div>

@if (isLoading) {
  <mat-progress-bar mode="indeterminate" [style]="{ height: '6px' }"></mat-progress-bar>
} @else {
<div class="pt-4 px-3 bg-white">
  <div class="flex flex-col gap-5 w-full p-2 pb-4">
    <div class="flex-grow-1">
      <mat-form-field>
        <mat-select [(value)]="selectedCategory"
                    (selectionChange)="categoryChange()"
                    placeholder="Category: Please Select"
                    data-pw="category">
          @for (item of categories; track $index) {
            <mat-option [value]="item">{{item.name}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div class="flex-grow-1">
      <mat-form-field>
        <mat-select [(value)]="selectedSubcategory"
                    placeholder="Subcategory: Please Select"
                    data-pw="subcategory"
                    [disabled]="!subCategories || subCategories.length === 0">
          @if (subCategories.length === 0) {
            <mat-option [value]="NA_SUBCATEGORY">{{NA_SUBCATEGORY.name}}</mat-option>
          } @else {
            @for (item of subCategories; track $index) {
              <mat-option [value]="item">{{item.name}}</mat-option>
            }
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div class="flex-grow-0">
      <button mat-stroked-button color="primary"
              class="new_button primary_materials_button"
              (click)="handleNewThread()"
              [disabled]="!isCategorySelectionValid">
        Start Conversation
      </button>
    </div>
  </div>
</div>
}
